import React, { useEffect, useState } from 'react';
import ProfileIcon from 'assets/svgs/profile.svg';
import './ProfileBox.scss';
import { useTranslation } from 'react-i18next';


const  ProfileBox =({userInfo, logOutFunction}) =>{
  const { t } = useTranslation();
  const ref = React.createRef();
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (ref && ref !== null) {
      const cur = ref.current;
      if (cur && !cur.contains(event.target)) {
        setIsOpen(false);
      }
    }
  };
  const toggleOpen = () => {
    setIsOpen(!isOpen)
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (<>
  <div className="profile-container" ref={ref}>
    <ProfileIcon
      id="profileIconId"
      onClick={toggleOpen}
    />
    {isOpen && (
      <div className="arrowBox adjusted">
        <div className="arrow"></div>

        <div className="profileBox-container" >
        <div className="profileBox-name">
          {userInfo &&
            `${userInfo.lastName}, ${userInfo.firstName}`}
        </div>
        <p className="profileBox-email">
          {userInfo && userInfo.emailAddress}
        </p>
        <div className="profileBox-controls">
          <a href="/profile"
            className="profileBox-button"
            onClick={() => setIsOpen(false)}>
            {t('common.labels.viewProfile')}
          </a>
          <span className="profileBox-link link" onClick={logOutFunction}>
          {t('common.labels.logOut')}
          </span>
        </div>
      </div>
      </div>
    )}
    </div>
  </>

  );

}

export default ProfileBox;
